import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { ListBanksQuery, Bank } from './Banks.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/banks`;

export async function listBanks(
  params: ListBanksQuery,
): Promise<PageResult<Bank>> {
  const result = (await api.get(`${CONTROLLER_URL}/filter`, params)) as unknown;

  return result as PageResult<Bank>;
}

export async function getBank(id: number): Promise<Bank> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Bank;
}
